import { sendUsageEventWithSession } from 'Webapp/shared/app/redux/actions/usage-actions';

export default {
  actions: { sendUsageEventWithSession },
};
